import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {replace} from "./Global";
import Vue from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/theme-chalk/index.css'



import * as ElementPlusIconsVue from '@element-plus/icons-vue'
// import { IntersectionObserver } from 'intersection-observer';
import 'dayjs/locale/zh-cn'
import locale from 'element-plus/lib/locale/lang/zh-cn'

import MetaInfo from 'vue-meta-info'
// import axios from "axios";
//引入css
import './assets/css/goubleCss.css'
import request from "@/utils/request";

const app = createApp(App)
app.config.warnHandler = () => null

// app.config.globalProperties.$yanzhengma = 'http://localhost:8084/captcha?time='
// app.config.globalProperties.$imgUrl = "http://localhost:8084/BackStage/productCategory/upload/img"
app.config.globalProperties.$yanzhengma='http://www.ifcores.com/api/captcha?time='
app.config.globalProperties.$imgUrl="http://www.ifcores.com/api/BackStage/productCategory/upload/img"
//全局方法
app.config.globalProperties.$replace = replace;

//浏览量
request.get("/views/add").then()


app.use(store)
    .use(router)
    .use(ElementPlus, {locale, size: 'normal'})
    .use(MetaInfo)
    .use(ElementPlusIconsVue)
    // .use(IntersectionObserver)
    //seo
    // .use(document.dispatchEvent(new Event('render-event')))
    .mount('#app')


